import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-center">
          <h1 className="text-2xl font-semibold text-gray-800">
            Nadine Rau & Mike Trepte GbR
          </h1>
        </div>
      </div>
    </header>
  );
};

export default Header;